import type { ReactNode } from 'react';
import './pick.css';

/** A select dressed as a quiet control, its label inside it: "Status  All". */
export function Pick({
  label,
  htmlFor,
  className,
  children,
}: {
  label: string;
  htmlFor: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div className={className ? `pick ${className}` : 'pick'}>
      <label className="pick-label" htmlFor={htmlFor}>
        {label}
      </label>
      {children}
      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
        <path d="M2.5 3.75 5 6.25l2.5-2.5" stroke="currentColor" strokeWidth="1.4" />
      </svg>
    </div>
  );
}
